import { render, staticRenderFns } from "./MultiSwitch.vue?vue&type=template&id=4fe9e6f6&scoped=true&"
import script from "./MultiSwitch.vue?vue&type=script&lang=js&"
export * from "./MultiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MultiSwitch.vue?vue&type=style&index=0&id=4fe9e6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9e6f6",
  null
  
)

export default component.exports